import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FormSelect from '../_shared/forms/FormSelect';

class JobCustomerDropdowns extends Component {
    constructor(props) {
        super(props);

        this.state = {
            customer: '',
            contact: '',
            job: '',
            contacts: [],
        };
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState(
            {
                [name]: value,
            },
            () => {
                if (name === 'customer') {
                    this.setContacts();
                }
            }
        );
    };

    setContacts = () => {
        let contacts = this.props.customers.filter((customer) => customer.id == this.state.customer)[0].contacts;
        this.setState({ contacts });
    };

    render() {
        return (
            <div className="row">
                <div className="form-group col-md-4">
                    <FormSelect
                        classes="form-control"
                        name="customer"
                        options={this.props.customers}
                        value={this.state.customer}
                        handleChange={this.handleChange}
                        label="customer"
                    />
                </div>
                <div className="form-group col-md-4">
                    <FormSelect
                        classes="form-control"
                        name="contact"
                        options={this.state.contacts}
                        value={this.state.contact}
                        handleChange={this.handleChange}
                        label="contact"
                    />
                </div>
                <div className="form-group col-md-4">
                    <FormSelect
                        classes="form-control"
                        name="job"
                        options={this.props.jobs}
                        value={this.state.job}
                        handleChange={this.handleChange}
                        label="job"
                    />
                </div>
            </div>
        );
    }
}

if (document.getElementById('jobDropdowns')) {
    let element = document.getElementById('jobDropdowns');
    ReactDOM.render(
        <JobCustomerDropdowns
            customers={JSON.parse(element.dataset.customers)}
            jobs={JSON.parse(element.dataset.jobs)}
        />,
        element
    );
}

export default JobCustomerDropdowns;
